async function requestJSON(path, options, fallbackMessage) {
  const res = await fetch(path, options);
  const data = await res.json();
  if (!data.success) {
    throw new Error(data.error || fallbackMessage);
  }
  return data;
}

export function getJSON(path, fallbackMessage = 'Request failed') {
  return requestJSON(path, undefined, fallbackMessage);
}

export function postJSON(path, body, fallbackMessage = 'Submission failed') {
  return requestJSON(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }, fallbackMessage);
}
